import React, { memo } from 'react';
import { Box, Container, SimpleGrid, Stat, StatLabel, StatNumber, StatHelpText } from '@chakra-ui/react';
import { motion } from 'framer-motion';
const MotionBox = motion(Box);
export const StatsSection = memo(function StatsSection() {
  const stats = [{
    label: 'AI Tools Tested',
    value: '15',
    description: 'And Counting'
  }, {
    label: 'Projects Built',
    value: '30+',
    description: 'With AI Assistance'
  }, {
    label: 'Time Saved',
    value: '10x',
    description: 'Compared to Traditional Methods'
  }, {
    label: 'Input Speed Boost',
    value: '4x',
    description: 'With Voice Dictation'
  }];
  return <Box bgGradient="linear(to-br, #2c084210, #1E73BE10)" py={12} width="100%" data-id="element-129">
      <Container maxW="container.xl" data-id="element-130">
        <SimpleGrid columns={{
        base: 2,
        md: 4
      }} spacing={8} data-id="element-131">
          {stats.map((stat, index) => <MotionBox key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} viewport={{
          once: true
        }} data-id="element-132">
              <Stat textAlign="center" data-id="element-133">
                <StatNumber fontSize="4xl" fontWeight="bold" bgGradient="linear(to-r, #2c0842, #1E73BE)" bgClip="text" data-id="element-134">
                  {stat.value}
                </StatNumber>
                <StatLabel fontSize="lg" fontWeight="semibold" mt={2} data-id="element-135">
                  {stat.label}
                </StatLabel>
                <StatHelpText fontSize="sm" color="gray.600" data-id="element-136">
                  {stat.description}
                </StatHelpText>
              </Stat>
            </MotionBox>)}
        </SimpleGrid>
      </Container>
    </Box>;
});